export default "__VITE_ASSET__BXyQ5FD7__"